export const pageview = () => {
	if (window.fbq) {
		window.fbq('track', 'PageView')
	}
}

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name: string, options = {}, env: string) => {
	if (window.fbq && env == 'prod') {
		window.fbq('track', name, options)
	}
}
